import React from 'react'

// In V2 we use “real” buttons to open dropdowns, hence the use of the
// “sites-button” class.
export default function DropdownButtonLink (props) {
  return <a className="sites-button download-button" {...props}>{props.children}</a>
}
